import { create } from "zustand";
import { tasks as seed } from "@/mocks/seed";
import type { Task } from "@/types";

/** Mock store for tasks when unauthenticated / API down (Phase 5.3). */
interface TasksState {
  active: Task[];
  archived: Task[];
  add: (task: Task) => void;
  update: (id: string, patch: Partial<Task>) => void;
  archive: (id: string) => void;
  restore: (id: string) => void;
}

export const useTasksStore = create<TasksState>((set) => ({
  active: seed,
  archived: [],
  add: (task) => set((s) => ({ active: [task, ...s.active] })),
  update: (id, patch) =>
    set((s) => ({ active: s.active.map((t) => (t.id === id ? { ...t, ...patch } : t)) })),
  archive: (id) =>
    set((s) => {
      const target = s.active.find((t) => t.id === id);
      if (!target) return s;
      return { active: s.active.filter((t) => t.id !== id), archived: [target, ...s.archived] };
    }),
  restore: (id) =>
    set((s) => {
      const target = s.archived.find((t) => t.id === id);
      if (!target) return s;
      return { archived: s.archived.filter((t) => t.id !== id), active: [target, ...s.active] };
    }),
}));
